import "../css/index.scss";

import $ from "jquery";
import "slick-carousel";
import "./modules/animations.js";
import "./modules/anime.js";
import "./modules/carousel.js";
import Search from "./modules/Search";

var search = new Search();
